import React from 'react';

const ErrorMessage = ({ error }) => <small className='field-error-msg'>{error}</small>;

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/forms/fields/errorMessage.js